import { render, staticRenderFns } from "./FreeGiftConfigurationIframe.vue?vue&type=template&id=fd4a1d96&"
import script from "./FreeGiftConfigurationIframe.vue?vue&type=script&lang=ts&"
export * from "./FreeGiftConfigurationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports